/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import merge from 'lodash/merge';
import { mergeReducers } from '../utils/async';
import { SHARED_PREFIX, SET_IMAGE_URL } from '../constants';

export const getReservationSummaryImageUrlReducer = (state, action) => {
    if (action.type === SHARED_PREFIX + SET_IMAGE_URL) {
        return merge(state, { reservationSummaryImageUrl: action.payload });
    }
    return state;
};

const INITIAL_STATE = {
    reservationSummaryImageUrl: '',
};

export const permitSharedReducers = mergeReducers(
    INITIAL_STATE,
    SHARED_PREFIX,
    getReservationSummaryImageUrlReducer
);

export const selectors = {
    getImageUrlSelector: (state) =>
        get(state, 'permitShared.reservationSummaryImageUrl', ''),
};

export default permitSharedReducers;
